import { render, staticRenderFns } from "./CaseList.vue?vue&type=template&id=69bab72a&scoped=true&"
import script from "./CaseList.vue?vue&type=script&lang=ts&"
export * from "./CaseList.vue?vue&type=script&lang=ts&"
import style0 from "./CaseList.vue?vue&type=style&index=0&id=69bab72a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69bab72a",
  null
  
)

export default component.exports